import { Component, ElementRef, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-ctl-wizard-steps',
  templateUrl: './CtlWizardSteps.html',
  styleUrls: ['./CtlWizardSteps.css']
})

export class CtlWizardSteps implements OnInit{

  @Input() ctlSteps=[];
  @Input() activestep;
textDir:any;
  constructor(private el: ElementRef) { 
    this.textDir = sessionStorage.getItem('textDir');
  }

  ngOnInit() {
    //
  }

  ngOnDestroy() {

  }

}